import { Component, computed, Inject, inject, signal, WritableSignal } from '@angular/core';
import { ActivityType } from '../../models/activity';
import { CommonModule } from '@angular/common';
import { InvitesComponent } from './invites/invites.component';
import { OtherActivitiesComponent } from './other-activities/other-activities.component';
import { NewsComponent } from "./news/news.component";
import { InvitesService } from '../../services/invites.service';

@Component({
  selector: 'app-activity-widget',
  standalone: true,
  imports: [CommonModule, InvitesComponent, OtherActivitiesComponent, NewsComponent, NewsComponent],
  templateUrl: './activity-widget.component.html',
  styleUrl: './activity-widget.component.css'
})
export class ActivityWidgetComponent {
  private invitesService = inject(InvitesService);

  widgetHeader: WritableSignal<string> = signal('');
  ActivityType = ActivityType; // Damit wir Enum in der HTML verwenden können
  hasInvites = computed(() => this.invitesService.invites().length > 0);

  // Liste von zusätzlichen Komponenten (Invites ist immer fix zuerst)
  activityTypes: ActivityType[] = [/*ActivityType.OtherComponent*/]; // Hier können weitere Typen hinzugefügt werden

  constructor(@Inject('label') public label: any) {
      this.widgetHeader.set(this.label);
  }
}
